module.exports = __webpack_public_path__ + "static/img/banner-fixed-ori.1cbdaf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed-ori.jpg
// module id = yBmi
// module chunks = 1